export interface IBiometricsInstructions {
  rostro: {
    title: string;
    subtitle: string;
    boxTitle: string;
    instructions: string[];
  };
  'documento-frontal': {
    title: string;
    subtitle: string;
    boxTitle: string;
    instructions: string[];
  };
  'documento-posterior': {
    title: string;
    subtitle: string;
    boxTitle: string;
    instructions: string[];
  };
}

export interface IBiometricsUpload {
  rostro: {
    title: string;
    subtitle: string;
    uploadComponent: {
      initial: string;
      failed: string;
    };
  };
  'documento-frontal': {
    title: string;
    subtitle: string;
    uploadComponent: {
      initial: string;
      failed: string;
    };
  };
  'documento-posterior': {
    title: string;
    subtitle: string;
    uploadComponent: {
      initial: string;
      failed: string;
    };
  };
}

export interface IFacialFeaturesMessages {
  FacialFeaturesMessages: string[];
  Image: string;
  IsAlive: boolean;
  Message: string;
  ScoreLiveness: number;
  StatusCode: number;
  UIdDevice: string;
  keyProcessLiveness: string;
}

export interface IBiometricsResults {
  title: string;
  subtitle: string;
  btnContinue: string;
  btnRedo: {
    web: string;
    mobile: string;
  };
}

export interface ISdkParams {
  BaseUrl: string;
  ProjectName: string;
  ApiKey: string;
  ProductId: string;
  UuiDevice: string;
  TokenAdo: {
    access_token: string;
  };
}

export interface IResultsFromBiometrics {
  rostro: IFacialFeaturesMessages;
  'documento-frontal': IFacialFeaturesMessages | SimpleUploadStatus;
  'documento-posterior': IFacialFeaturesMessages | SimpleUploadStatus;
}

export interface IPresignedUrls {
  ExpiresTime: number;
  UploadDocumentBackSide: string;
  UploadDocumentFrontSide: string;
}

export enum EBiometricsType {
  FACE = 'rostro',
  DOCUMENT_FRONTAL = 'documento-frontal',
  DOCUMENT_REAR = 'documento-posterior'
}

export enum EBiometricsDocumentSide {
  FRONTAL = 'frontal',
  REAR = 'posterior'
}

export interface SimpleUploadStatus {
  status: UStatus;
  file: File | null;
  text: string;
  types: string;
  Image: string;
}

export interface HelperTexts {
  loading: {
    text: string;
  };
  initial: {
    text: string;
  };
  failed: {
    text: string;
  };
  success: {
    text: string;
  };
}

export enum UStatus {
  INITIAL = 'INITIAL',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  LOADING = 'LOADING'
}

export interface IRoutingBiometrics {
  [key: string]: {
    instructions: {
      to: string;
      previous?: string;
      retake?: string;
    };
    results: {
      to: string;
      previous?: string;
      retake?: string;
    };
    launcher: {
      to: string;
      previous?: string;
      retake?: string;
    };
    upload: {
      to: string;
      previous?: string;
      retake?: string;
    };
  };
}

export enum EscreenKeys {
  INSTRUCTIONS = 'instructions',
  LAUNCHER = 'launcher',
  RESULT = 'results',
  UPLOAD = 'upload'
}

export enum ERoute {
  WEB = 'web',
  MOBILE = 'mobile'
}

interface DataCustomer {
  birthDate: string;
  documentType: number;
  firstName: string;
  firstSurname: string;
  gender: string;
  identificationNumber: number;
  issueDate: string;
  secondName: string;
  secondSurname: string;
}

interface BiometricResultData {
  detail: string;
  message: string;
  messageCode: string;
}

interface BiometricResult {
  responseCode: number;
  transactionId: string;
  data: BiometricResultData;
  dataCustomer: DataCustomer;
}

export interface BiometricsResponse {
  data: {
    onBiometricResult: BiometricResult;
  };
}
